import { api } from 'lq-ui'

export default () => api.get('/proposal')
  .then((proposals) => (proposals))
